export default __webpack_public_path__ + "static/media/Background 5_00043.c159cad8.png";